import { render, staticRenderFns } from "./promo-box.vue?vue&type=template&id=d64a3c3c&scoped=true&"
import script from "./promo-box.vue?vue&type=script&lang=js&"
export * from "./promo-box.vue?vue&type=script&lang=js&"
import style0 from "./promo-box.vue?vue&type=style&index=0&id=d64a3c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64a3c3c",
  null
  
)

export default component.exports